module.exports = __webpack_public_path__ + "img/XT-Antorchas.3667f48a.png";